import { render, staticRenderFns } from "./myDormitory.vue?vue&type=template&id=5500b703"
import script from "./myDormitory.vue?vue&type=script&lang=js"
export * from "./myDormitory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports